import { proxy } from 'valtio';

export const environmentState = proxy({
  apiUrl: '',
  countryCode: '',
});
